let contentsNs = contentsNs || {};
contentsNs.CONS = contentsNs.CONS || {};
contentsNs.UTIL = contentsNs.UTIL || {};

// Document Ready
$(()=> {

    let GourmetAry = [];
    let GiftAry = [];
    let ItemAry = [];

    // 夏グルメ
    contentsNs.UTIL.getGourmetData().done((aLoadData)=> {
        GourmetAry = contentsNs.UTIL.sortData(aLoadData);
        GourmetAry = contentsNs.UTIL.createOutputData(GourmetAry);
        contentsNs.UTIL.initGourmetSelect(GourmetAry);
        contentsNs.UTIL.outputGourmetHtml(GourmetAry);
        contentsNs.UTIL.showGourmet();
    });

    // 夏ギフト
    // contentsNs.UTIL.getGiftData().done((aLoadData)=> {
    //     GiftAry = contentsNs.UTIL.sortData(aLoadData);
    //     GiftAry = contentsNs.UTIL.createOutputData(GiftAry);
    //     contentsNs.UTIL.initGiftSelect(GiftAry);
    //     contentsNs.UTIL.outputGiftHtml(GiftAry);
    //     contentsNs.UTIL.showGift();
    // });

    // 夏アイテム
    contentsNs.UTIL.getItemData().done((aLoadData)=> {
        ItemAry = contentsNs.UTIL.sortData(aLoadData);
        ItemAry = contentsNs.UTIL.createOutputData(ItemAry);
        contentsNs.UTIL.initItemSelect(ItemAry);
        contentsNs.UTIL.outputItemHtml(ItemAry);
        contentsNs.UTIL.showItem();
    });

    // もっと見るボタン
    $('.feature-area--gourmet .feature-btn').click(function() { contentsNs.UTIL.showGourmet(); });
    $('.feature-area--gift .feature-btn').click(function() { contentsNs.UTIL.showGift(); });
    $('.feature-area--item .feature-btn').click(function() { contentsNs.UTIL.showItem(); });

    // 店舗を選択
    $('.feature-area--gourmet #store_code_select').change(function() {
        let selectedCode = $(this).val();
        let GourmetAryTmp = GourmetAry;
        GourmetAryTmp = contentsNs.UTIL.storeFilter(GourmetAryTmp, selectedCode);
        contentsNs.UTIL.outputGourmetHtml(GourmetAryTmp);
        contentsNs.UTIL.showGourmet();
    });
    $('.feature-area--gift #store_code_select').change(function() {
        let selectedCode = $(this).val();
        let GiftAryTmp = GiftAry;
        GiftAryTmp = contentsNs.UTIL.storeFilter(GiftAryTmp, selectedCode);
        contentsNs.UTIL.outputGiftHtml(GiftAryTmp);
        contentsNs.UTIL.showGift();
    });
    $('.feature-area--item #store_code_select').change(function() {
        let selectedCode = $(this).val();
        let ItemAryTmp = ItemAry;
        ItemAryTmp = contentsNs.UTIL.storeFilter(ItemAryTmp, selectedCode);
        contentsNs.UTIL.outputItemHtml(ItemAryTmp);
        contentsNs.UTIL.showItem();
    });

    // Inview
    const intersectionObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                $(entry.target).addClass('inview')
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.1 });
    const $targets = $('.flag');
    _.each($targets, ($target) => {
        intersectionObserver.observe($target);
    });

    // js-show
    // onEnter はスクロールで開始位置をまたいだときだけ発火する。
    // すでに画面内の状態で読み込むとまたがないので、その場で active を付ける。
    const activateShowItem = (self) => {
        self.trigger.classList.add('active');
    };
    const showItems = document.querySelectorAll('.js-show');
    showItems.forEach((item) => {
        const trigger = ScrollTrigger.create({
            trigger: item,
            start: 'top 80%',
            onEnter: activateShowItem,
            onRefresh: (self) => {
                if (self.isActive) {
                    activateShowItem(self);
                }
            }
        });
        if (trigger.isActive) {
            activateShowItem(trigger);
        }
    });
    window.addEventListener('load', () => {
        ScrollTrigger.refresh();
    });

    // キーワード: 画面内に入ってからビクンビクンを開始
    document.querySelectorAll('.feature-keyword').forEach((item) => {
        ScrollTrigger.create({
            trigger: item,
            start: 'top 80%',
            once: true,
            onEnter: (self) => {
                self.trigger.classList.add('is-inview');
            }
        });
    });

    // ヒーロー足跡: animation forwards 依存をやめ、完了後に表示を固定
    // （スクロールで画面外→復帰時に opacity が 0 に戻る対策）
    document.querySelectorAll('.hero-foot01, .hero-foot02, .hero-foot03').forEach((el) => {
        el.addEventListener('animationend', () => {
            el.classList.add('is-visible');
        }, { once: true });
    });

    contentsNs.UTIL.initShareList();
    contentsNs.UTIL.initCampaignSlider();
    contentsNs.UTIL.initKeywordAnchor();
    contentsNs.UTIL.initKeywordForm();
});

// Functions
(()=> {
    /**
    * データ絞り込み
    */
    contentsNs.UTIL.storeFilter = (dataAry, aStcd)=> {
        return dataAry.filter(item => item.store_code == aStcd);
    };

    /**
    * 配列をソート
    */
    contentsNs.UTIL.sortData = (dataAry)=> {
        dataAry.sort((a, b)=> {
            if(a.updated < b.updated) return 1;
            if(a.updated > b.updated) return -1;
            return 0;
        });
        return dataAry;
    };

    /**
    * 出力データを作成
    */
    contentsNs.UTIL.createOutputData = (dataAry)=> {
        let now = new Date();
        _.each(dataAry, (data) => {
            switch(data.type) {
                case cons.IDENTIFY_TTS_SHOPNEWS:
                    switch(data.class) {
                        case '01':
                            data.linkUrl = `/${data.store_code}/recommend/detail.html?article_seq=${data.seq}&article_type=sho`;
                            break;
                        case '02':
                            data.linkUrl = `/${data.store_code}/sale-campaign/detail.html?article_seq=${data.seq}&article_type=sho`;
                            break;
                        case '03':
                            data.linkUrl = `/${data.store_code}/news/detail.html?article_seq=${data.seq}&article_type=sho`;
                            break;
                    }
                    break;
                case cons.IDENTIFY_TTS_STORENEWS:
                    switch(data.class) {
                        case '01':
                            data.linkUrl = `/${data.store_code}/event/detail.html?article_seq=${data.seq}&article_type=sto`;
                            break;
                        case '02':
                            data.linkUrl = `/${data.store_code}/news/detail.html?article_seq=${data.seq}&article_type=sto`;
                            break;
                        case '03':
                            data.linkUrl = `/${data.store_code}/feature/detail.html?article_seq=${data.seq}&article_type=sto`;
                            break;
                        case '04':
                            data.linkUrl = `/${data.store_code}/recommend/detail.html?article_seq=${data.seq}&article_type=sto`;
                            break;
                        case '05':
                            data.linkUrl = `/${data.store_code}/sale-campaign/detail.html?article_seq=${data.seq}&article_type=sto`;
                            break;
                        case '09':
                            data.linkUrl = `/${data.store_code}/newshop/detail.html?article_seq=${data.seq}&article_type=sto`;
                            break;
                    }
                    break;
            }
            let updated = new Date(data.updated.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, "$1-$2-$3T$4:$5:$6"));
            data.updated = `${String(updated.getFullYear()).slice(-2)}.${updated.getMonth()+1}.${updated.getDate()}up`;
            data.new = now.getTime() - updated.getTime() <= 7 * 24 * 60 * 60 * 1000 ? true : false;
            data.main_img = util.imgDataPath(data.main_img, cons.IMG_TYPE.AUTO);
            data.store_name = cons.STORE_CODE_LIST[data.store_code];
        });
        return dataAry;
    };

    /**
    * 夏グルメJSONデータ取得
    */
    contentsNs.UTIL.getGourmetData = ()=> {
        let $defer = $.Deferred();
        let jsonUrl = util.contentsLoadPath('/apps/2025halloween_0.json');

        $.ajax({
            dataType: 'json',
            timeOut: 9000,
            url: jsonUrl,
            cache: false
        }).done((data, textStatus, jqXHR)=> {
            $defer.resolve(data);
        }).fail((jqXHR, textStatus, errorThrown) => {
            $defer.reject();
        });
        return $defer.promise();
    };

    /**
	 * 夏グルメセレクトボックスの無効な選択肢を削除
	 */
    contentsNs.UTIL.initGourmetSelect = (dataAry)=> {
        let stcdAry = [];
        _.each(dataAry, (data) => {
            if(!stcdAry.includes(data.store_code)) {
                stcdAry.push(data.store_code);
            }
        });
        $('.feature-area--gourmet #store_code_select option').each(function() {
            if($(this).val() != "" && !stcdAry.includes($(this).val())) {
                $(this).remove();
            }
        });
    };

	/**
	 * 夏グルメ取得結果をHTMLに出力
	 */
    contentsNs.UTIL.outputGourmetHtml = (GourmetAry)=> {
		let $tmpl = $('#tmplGourmet');
		let $output = $('.feature-area--gourmet .feature-list');
		let outputHtml = $tmpl.render(GourmetAry);
		$output.html(outputHtml);
    };

    /**
	 * 夏グルメ8件表示
	 */
    contentsNs.UTIL.showGourmet = ()=> {
        for(var i = 0; i < 8 && 0 < $('.feature-area--gourmet .feature-list__item:hidden').length; i++) {
            $('.feature-area--gourmet .feature-list__item:hidden').eq(0).show();
        }
        if($('.feature-area--gourmet .feature-list__item:hidden').length == 0) {
            $('.feature-area--gourmet .feature-btn').hide();
        }
    };

    /**
    * 夏ギフトJSONデータ取得
    */
    contentsNs.UTIL.getGiftData = ()=> {
        let $defer = $.Deferred();
        let jsonUrl = util.contentsLoadPath('/apps/2025halloween_1.json');

        $.ajax({
            dataType: 'json',
            timeOut: 9000,
            url: jsonUrl,
            cache: false
        }).done((data, textStatus, jqXHR)=> {
            $defer.resolve(data);
        }).fail((jqXHR, textStatus, errorThrown) => {
            $defer.reject();
        });
        return $defer.promise();
    };

    /**
	 * 夏ギフトセレクトボックスの無効な選択肢を削除
	 */
    contentsNs.UTIL.initGiftSelect = (dataAry)=> {
        let stcdAry = [];
        _.each(dataAry, (data) => {
            if(!stcdAry.includes(data.store_code)) {
                stcdAry.push(data.store_code);
            }
        });
        $('.feature-area--gift #store_code_select option').each(function() {
            if($(this).val() != "" && !stcdAry.includes($(this).val())) {
                $(this).remove();
            }
        });
    };

	/**
	 * 夏ギフト取得結果をHTMLに出力
	 */
    contentsNs.UTIL.outputGiftHtml = (GiftAry)=> {
		let $tmpl = $('#tmplGift');
		let $output = $('.feature-area--gift .feature-list');
		let outputHtml = $tmpl.render(GiftAry);
		$output.html(outputHtml);
    };

    /**
	 * 夏ギフト8件表示
	 */
    contentsNs.UTIL.showGift = ()=> {
        for(var i = 0; i < 8 && 0 < $('.feature-area--gift .feature-list__item:hidden').length; i++) {
            $('.feature-area--gift .feature-list__item:hidden').eq(0).show();
        }
        if($('.feature-area--gift .feature-list__item:hidden').length == 0) {
            $('.feature-area--gift .feature-btn').hide();
        }
    };

    /**
    * 夏アイテムJSONデータ取得
    */
    contentsNs.UTIL.getItemData = ()=> {
        let $defer = $.Deferred();
        let jsonUrl = util.contentsLoadPath('/apps/2025halloween_1.json');

        $.ajax({
            dataType: 'json',
            timeOut: 9000,
            url: jsonUrl,
            cache: false
        }).done((data, textStatus, jqXHR)=> {
            $defer.resolve(data);
        }).fail((jqXHR, textStatus, errorThrown) => {
            $defer.reject();
        });
        return $defer.promise();
    };

    /**
	 * 夏アイテムセレクトボックスの無効な選択肢を削除
	 */
    contentsNs.UTIL.initItemSelect = (dataAry)=> {
        let stcdAry = [];
        _.each(dataAry, (data) => {
            if(!stcdAry.includes(data.store_code)) {
                stcdAry.push(data.store_code);
            }
        });
        $('.feature-area--item #store_code_select option').each(function() {
            if($(this).val() != "" && !stcdAry.includes($(this).val())) {
                $(this).remove();
            }
        });
    };

	/**
	 * 夏アイテム取得結果をHTMLに出力
	 */
    contentsNs.UTIL.outputItemHtml = (ItemAry)=> {
		let $tmpl = $('#tmplItem');
		let $output = $('.feature-area--item .feature-list');
		let outputHtml = $tmpl.render(ItemAry);
		$output.html(outputHtml);
    };

    /**
	 * 夏アイテム8件表示
	 */
    contentsNs.UTIL.showItem = ()=> {
        for(var i = 0; i < 8 && 0 < $('.feature-area--item .feature-list__item:hidden').length; i++) {
            $('.feature-area--item .feature-list__item:hidden').eq(0).show();
        }
        if($('.feature-area--item .feature-list__item:hidden').length == 0) {
            $('.feature-area--item .feature-btn').hide();
        }
    };

    /**
     * 対象ショップリスト（CSV）
     * 夏グルメの share/list.es と同じく、店舗選択でフロア・ショップを表に出す。
     * ページ内に #store_code_select が複数あるため #l-share-list に限定する。
     */
    const SHARE_LIST_CSV_URL = '/halloween/7e4b9a2f0c86d315a8f62c09/list.csv';
    const SHARE_LIST_ANCHOR_ID = 'l-share-list';
    const SHARE_LIST_CSV_IDX = {
        storeCode : 0,
        storeName : 1,
        floor     : 2,
        shopName  : 3,
        shopId    : 4
    };

    contentsNs.UTIL.shareListStoreMap = {};
    contentsNs.UTIL.shareListStores = [];

    contentsNs.UTIL.shareListRoot = ()=> {
        return $(`#${SHARE_LIST_ANCHOR_ID}`);
    };

    contentsNs.UTIL.parseShareListCsv = (csvData)=> {
        const storeMap = {};
        const stores = [];

        $.csv.toArrays(csvData).forEach((row, index)=> {
            if(index === 0) {
                return;
            }

            const storeCode = (row[SHARE_LIST_CSV_IDX.storeCode] || '').trim();
            if(!storeCode) {
                return;
            }

            if(!storeMap[storeCode]) {
                storeMap[storeCode] = [];
                stores.push({
                    code : storeCode,
                    name : (row[SHARE_LIST_CSV_IDX.storeName] || '').trim()
                });
            }

            storeMap[storeCode].push({
                floor    : (row[SHARE_LIST_CSV_IDX.floor] || '').trim(),
                shopName : (row[SHARE_LIST_CSV_IDX.shopName] || '').trim(),
                shopId   : (row[SHARE_LIST_CSV_IDX.shopId] || '').trim()
            });
        });

        contentsNs.UTIL.shareListStores = stores;
        return storeMap;
    };

    contentsNs.UTIL.renderShareListOptions = ()=> {
        const $select = contentsNs.UTIL.shareListRoot().find('#store_code_select');

        contentsNs.UTIL.shareListStores.forEach((store)=> {
            $select.append($('<option>', {
                value : store.code,
                text  : store.name
            }));
        });
    };

    contentsNs.UTIL.escapeHtml = (text)=> {
        return String(text || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    };

    contentsNs.UTIL.updateShareList = (selectedCode)=> {
        const $root = contentsNs.UTIL.shareListRoot();
        const $container = $root.find('#store_data_container');
        const $tbody = $container.find('table tbody');

        if(!selectedCode) {
            $container.hide();
            $tbody.empty();
            return;
        }

        const shops = contentsNs.UTIL.shareListStoreMap[selectedCode] || [];
        const rowsHtml = shops.map((shop)=> {
            const shopCell = shop.shopId
                ? `<a href="/${selectedCode}/shop-guide/shop-detail.html?shop_id=${shop.shopId}">${contentsNs.UTIL.escapeHtml(shop.shopName)}</a>`
                : contentsNs.UTIL.escapeHtml(shop.shopName);

            return `<tr><td class="floor">${contentsNs.UTIL.escapeHtml(shop.floor)}</td><td class="shop">${shopCell}</td></tr>`;
        }).join('');

        $tbody.html(rowsHtml);
        $container.show();
    };

    contentsNs.UTIL.loadShareList = ()=> {
        return $.ajax({
            url      : SHARE_LIST_CSV_URL,
            type     : 'POST',
            dataType : 'text'
        })
        .done((csvData)=> {
            contentsNs.UTIL.shareListStoreMap = contentsNs.UTIL.parseShareListCsv(csvData);
            contentsNs.UTIL.renderShareListOptions();
        });
    };

    contentsNs.UTIL.getUrlParam = (key)=> {
        const params = new URLSearchParams(window.location.search);
        return params.get(key) || '';
    };

    contentsNs.UTIL.getHeaderHeight = ()=> {
        if(window.matchMedia('(min-width: 768px)').matches) {
            return 81;
        }
        return window.innerWidth * 114 / 750;
    };

    contentsNs.UTIL.getShareListStoreCode = ()=> {
        const storeCode = contentsNs.UTIL.getUrlParam('store') || contentsNs.UTIL.getUrlParam('id');
        if(!storeCode) {
            return '';
        }

        return /^\d+$/.test(storeCode) ? storeCode.padStart(3, '0') : storeCode;
    };

    contentsNs.UTIL.shouldApplyShareListUrlState = ()=> {
        const hash = window.location.hash.replace('#', '');
        return hash === SHARE_LIST_ANCHOR_ID || !!contentsNs.UTIL.getShareListStoreCode();
    };

    contentsNs.UTIL.scrollToShareList = ()=> {
        const $target = contentsNs.UTIL.shareListRoot();

        if(!$target.length) {
            return;
        }

        const headerHeight = contentsNs.UTIL.getHeaderHeight();
        const scrollTop = Math.max(0, $target.offset().top - headerHeight - 16);

        window.scrollTo({
            top      : scrollTop,
            behavior : 'smooth'
        });
    };

    contentsNs.UTIL.isShareListAnchorLink = (href)=> {
        if(!href) {
            return false;
        }

        const linkUrl = new URL(href, window.location.href);
        return linkUrl.hash === `#${SHARE_LIST_ANCHOR_ID}`
            && linkUrl.pathname === window.location.pathname;
    };

    contentsNs.UTIL.bindShareListAnchor = ()=> {
        $(document).on('click', 'a[href*="#l-share-list"]', (event)=> {
            if(!contentsNs.UTIL.isShareListAnchorLink(event.currentTarget.href)) {
                return;
            }

            event.preventDefault();

            if(window.location.hash !== `#${SHARE_LIST_ANCHOR_ID}`) {
                history.pushState(null, '', `#${SHARE_LIST_ANCHOR_ID}`);
            }

            contentsNs.UTIL.scrollToShareList();
        });

        $(window).on('hashchange', ()=> {
            if(window.location.hash.replace('#', '') === SHARE_LIST_ANCHOR_ID) {
                contentsNs.UTIL.scrollToShareList();
            }
        });
    };

    contentsNs.UTIL.applyShareListUrlState = ()=> {
        if(!contentsNs.UTIL.shouldApplyShareListUrlState()) {
            return;
        }

        const storeCode = contentsNs.UTIL.getShareListStoreCode();
        const $select = contentsNs.UTIL.shareListRoot().find('#store_code_select');
        const shouldScroll = window.location.hash.replace('#', '') === SHARE_LIST_ANCHOR_ID;

        if(storeCode && $select.length && $select.find(`option[value="${storeCode}"]`).length) {
            $select.val(storeCode).trigger('change');
        }

        if(shouldScroll) {
            requestAnimationFrame(()=> {
                contentsNs.UTIL.scrollToShareList();
            });
        }
    };

    contentsNs.UTIL.initShareListAnchor = ()=> {
        if(!contentsNs.UTIL.shareListRoot().length || !contentsNs.UTIL.shouldApplyShareListUrlState()) {
            return;
        }

        let retryCount = 0;
        const retryTimer = setInterval(()=> {
            retryCount++;
            contentsNs.UTIL.applyShareListUrlState();

            const storeCode = contentsNs.UTIL.getShareListStoreCode();
            const $select = contentsNs.UTIL.shareListRoot().find('#store_code_select');
            const isStoreReady = !storeCode
                || ($select.find('option').length > 1 && $select.find(`option[value="${storeCode}"]`).length);

            if(isStoreReady || retryCount >= 50) {
                clearInterval(retryTimer);
            }
        }, 100);
    };

    /**
     * 参加手順スライダー
     */
    contentsNs.UTIL.initCampaignSlider = ()=> {
        const $slider = $('.campaign-slider');
        const $wrap = $('.campaign-slider-wrap');

        if(!$slider.length) {
            return;
        }

        let sliderMode = '';

        const getSlideMetrics = ()=> {
            const wrapWidth = $wrap.outerWidth() || $(window).width() || 750;

            if(window.innerWidth < 768) {
                const slideImageWidth = Math.round(wrapWidth * (560 / 750));
                const slideGap = Math.round(wrapWidth * (40 / 750));

                return {
                    slideWidth : slideImageWidth + slideGap
                };
            }

            return {
                slideWidth : 726
            };
        };

        const getCenterPadding = ()=> {
            const wrapWidth = $wrap.outerWidth() || $(window).width() || getSlideMetrics().slideWidth;

            return Math.max(0, Math.floor((wrapWidth - getSlideMetrics().slideWidth) / 2));
        };

        const destroy = ()=> {
            if($slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }
            sliderMode = '';
        };

        const init = ()=> {
            const mode = window.innerWidth < 768 ? 'sp' : 'pc';

            if($slider.hasClass('slick-initialized')) {
                if(sliderMode === mode) {
                    $slider.slick('slickSetOption', 'centerPadding', `${getCenterPadding()}px`, true);
                    $slider.slick('setPosition');
                    return;
                }

                destroy();
            }

            sliderMode = mode;

            $slider.slick({
                centerMode       : true,
                centerPadding    : `${getCenterPadding()}px`,
                slidesToShow     : 1,
                slidesToScroll   : 1,
                infinite         : true,
                arrows           : true,
                dots             : true,
                speed            : 400,
                variableWidth    : true,
                appendArrows     : $wrap,
                appendDots       : $wrap,
                prevArrow        : '<button type="button" class="campaign-arrow campaign-arrow--prev" aria-label="前のステップ"><span aria-hidden="true"></span></button>',
                nextArrow        : '<button type="button" class="campaign-arrow campaign-arrow--next" aria-label="次のステップ"><span aria-hidden="true"></span></button>'
            });

            $slider.find('img').each((index, img)=> {
                if(img.complete) {
                    return;
                }
                $(img).one('load', ()=> {
                    if($slider.hasClass('slick-initialized')) {
                        $slider.slick('setPosition');
                    }
                });
            });
        };

        init();
        $(window).on('resize', init);
    };

    /**
     * 画面下の「キーワード入力はこちら」
     * ページ上部では隠し、少しスクロールしてから出す。
     */
    contentsNs.UTIL.initKeywordAnchor = ()=> {
        const bar = document.querySelector('.keyword-fixed');
        const revealOffset = 200;

        if(!bar) {
            return;
        }

        const updateBar = ()=> {
            bar.classList.toggle('is-visible', window.scrollY >= revealOffset);
        };

        window.addEventListener('scroll', updateBar, { passive: true });
        updateBar();
    };

    /**
     * キーワード入力フォームを AJAX 送信する。
     * 正解なら秘密ページへ遷移、不正解ならエラー表示。
     */
    contentsNs.UTIL.initKeywordForm = ()=> {
        const $form = $('.campaign-input-form-form');
        if(!$form.length) {
            return;
        }

        $form.on('submit', (event)=> {
            event.preventDefault();
            $form.removeClass('is-error');

            $.post($form.attr('action'), $form.serialize())
                .done((data)=> {
                    if(data && data.ok && data.redirect) {
                        location.href = data.redirect;
                        return;
                    }
                    $form.addClass('is-error');
                })
                .fail(()=> {
                    $form.addClass('is-error');
                });
        });
    };

    contentsNs.UTIL.initShareList = ()=> {
        const $root = contentsNs.UTIL.shareListRoot();
        const $select = $root.find('#store_code_select');

        contentsNs.UTIL.bindShareListAnchor();

        if(!$select.length) {
            return;
        }

        $root.find('#store_data_container').hide();

        $select.on('change', ()=> {
            contentsNs.UTIL.updateShareList($select.val());
        });

        contentsNs.UTIL.loadShareList().always(()=> {
            contentsNs.UTIL.initShareListAnchor();
        });
    };

})();
